import React, { useState } from "react";
import PrimaryButton from "../buttons/PrimaryButton.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import Space from "../layout/Space.js";
import { useEffect } from "react";
import {
  createDoc,
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getRefFromId,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import CheckBoxGrey from "../textfields/CheckBoxGrey.js";

import moment from "moment";
import SmallSpinner from "../loading/SmallSpinner.js";
import modifThermal from "../api/folder/modifThermal.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import TextField2 from "../textfields/TextField2.js";
import TextFieldEmail from "../textfields/TextFieldEmail.js";
import { useAppContext } from "../config/AppContext.js";
import { useSnackbar } from "notistack";
import { Timestamp } from "firebase/firestore";
import sendDVemail from "../api/sign/sendDVemail.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import { useNavigate } from "react-router-dom";
import DropDownGPT1X from "../dropdowns/DropDownGPT1X.js";
import { useAuth } from "../auth/FirebaseAuth.js";
import { getUserById } from "../models/UserFunctions.js";
import createNewFolder from "../api/create/createNewFolder.js";
import DropDownGPT0X from "../dropdowns/DropDownGTP0X.js";
import { set } from "date-fns";
import Icon1 from "../icons/Icon.js";
import { getCommunWorkspace } from "../pages/folder_pages/FolderHelpers.js";
import { firstPlan } from "../hexagone/VisibilityHelpers.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import {
  FolderTypeDropdown,
  handleFetchPacksBasedOnFolderType,
} from "../pages/folder_pages/NewFolder.js";
import {
  ToggleLogementBrick,
  ToggleSettingsBrick,
} from "../textfields/EasySwitch.js";
import { getOrgById } from "../models/OrgFunctions.js";
import addClientPartners from "../api/add/addClientPartners.js";

const CreateFolderFromDevis = ({
  invoiceData,
  orgData,
  onClose,
  navigateWorkspace,
  masterData,
}) => {
  const [loadingData = false, setLoadingData] = useState(false);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [packOptions, setPackOptions] = useState([]);
  const [selectedPack, setSelectedPack] = useState(null);
  const [loadingNewFolder, setLoadingNewFolder] = useState(false);
  const { currentUser, loading } = useAuth();
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [folder_type, setFolderType] = useState(firstPlan(orgData));
  const [partnerWorkspace, setPartnerWorkspace] = useState(null);
  const [plans_files, setPlansFiles] = useState(invoiceData.plans_files || []);

  const [repertoiresOptions, setRepertoiresOptions] = useState([]);
  const [use_facture_mat, setUseFactureMat] = useState(false);
  const [payment_allowed, setPaymentAllowed] = useState(
    invoiceData?.client_type === "particulier" ? true : false
  );
  useEffect(() => {
    handleFetchData();
  }, [currentUser]);

  const handleFetchData = async () => {
    if (currentUser) {
      const user = await getUserById(currentUser.uid);
      const org = await getOrgById(user.org_id);

      if (invoiceData.client_type !== "particulier" && invoiceData.client_id) {
        let client = await getOrgById(invoiceData.client_id);
        let partnerWorkspace = await getCommunWorkspace(client, masterData);
        setPartnerWorkspace(partnerWorkspace);
        setPaymentAllowed(
          partnerWorkspace?.permissions?.payment_allowed || false
        );
      }

      await handleFetchPacksBasedOnFolderType(
        setPackOptions,
        masterData,
        setSelectedPack
      );
    }
  };

  const handleFetchDocuments = async (selectedPack) => {
    if (selectedPack) {
      let matching_pack = packOptions.find((p) => p.value === selectedPack);
      if (!matching_pack) {
        console.error("No matching pack found for selectedPack:", selectedPack);
        return;
      }
      let pack_type = matching_pack.type || "infiltro";
      setFolderType(matching_pack.type || "infiltro");
      let actual_pack = await getDocDataById("prestation", selectedPack);
      const docxs = actual_pack.documents;
      setRepertoiresOptions(
        docxs.map((doc) => {
          return { value: doc.id, label: doc.name };
        })
      );
    }
  };

  useEffect(() => {
    handleFetchDocuments(selectedPack);
  }, [selectedPack]);

  const handleCreateFolder = async () => {
    if (loadingNewFolder) return;
    setLoadingNewFolder(true);

    await updateDocDataFieldApi(
      invoiceData.ref,
      "plans_files",
      plans_files,
      prefix
    );

    let clientData;
    if (invoiceData?.client_id) {
      clientData = await getOrgById(invoiceData.client_id);
    }

    const token = await getOrRefreshFirebaseToken();
    const interventiondone = false;
    const postal = invoiceData?.postal_projet || "";
    const adresse = invoiceData?.adresse_projet || "";
    const pack = "Devis";
    const ville = invoiceData?.ville_projet || "";
    const nom = invoiceData?.nom || "";
    const first_name = invoiceData?.first_name || "";
    const comments = "";
    const emailclient = invoiceData?.email || "";
    const phoneclient = invoiceData?.tel || "";
    const amount = parseInt(invoiceData?.total_ttc * 100) || 0;
    const date = "../../....";
    const heure = "0";
    const minute = 0;
    const startdate = "../../....";
    const enddate = "../../....";
    const clientId = invoiceData?.client_id || "particulier";
    const packid = selectedPack;
    const master_id = masterData.id || "";
    const author_id = orgData.id || "";
    const structure = invoiceData?.structure_type || "maison_individuelle";

    const clientmemberid = "vide";
    let new_folder_ref = await createNewFolder(
      token,
      prefix,

      payment_allowed,
      use_facture_mat,
      folder_type,
      interventiondone,
      postal,
      adresse,
      pack,
      ville,
      nom,
      first_name,
      "",
      comments,
      invoiceData.id,
      {
        email: emailclient,
        phone: phoneclient,
        amount: amount,
        postal: invoiceData.postal_client,
        city: invoiceData.ville_client,
        address: invoiceData.adresse_client,
        name: invoiceData.nom_client,
      },
      clientmemberid,
      date,
      heure,
      minute,
      startdate,
      enddate,
      clientId,
      packid,
      structure,
      [],
      master_id,
      author_id,
      invoiceData?.marque || "",
      {
        email: invoiceData.email_client,
        phone: invoiceData.tel_client,
      },
      null
    );

    handleClickVariant("Dossier créé", "success");
    if (clientId != "particulier") {
      await addClientPartners(new_folder_ref.id, clientId, token, prefix);
    }
    await updateDocDataFieldApi(
      invoiceData.ref,
      "folder_ref",
      new_folder_ref,
      prefix
    );
    let history_events = invoiceData.history_events || [];
    history_events.push({
      name: "Dossier créé",
      date: getFlutterTime(),
    });
    await updateDocDataFieldApi(
      invoiceData.ref,
      "history_events",
      history_events,
      prefix
    );

    setLoadingNewFolder(false);

    handleClickVariant("Partenaires affiliés ajoutés", "success");
    navigateWorkspace("/folder/" + new_folder_ref.id);
  };

  return (
    <div className="flex flex-col max-w-c600 w-full bg-white rounded-3xl">
      <div className=" text-h3 flex flex-row justify-between  p-4  border-b-1">
        Création de dossier
        <div className="flex text-shadow_50 cursor-pointer" onClick={onClose}>
          Fermer
        </div>
      </div>{" "}
      <div className="p-4 flex flex-col bg-neutral-50 gap-1">
        <div className=" text-h3 text-shadow_50">
          Toutes les informations du devis seront transférées dans le dossier
        </div>
        <div className=" text-h3 text-shadow_50 ">
          Sélectionnez la prestation pour le dossier
        </div>

        <DropDownGPTS3
          items={packOptions}
          value={selectedPack}
          onChange={(e) => setSelectedPack(e.value)}
          label="Prestation"
          className="w-full bg-white"
          mandatory={true}
          transparent={false}
        />
        <div className="text-h3 text-shadow_50">
          Vous devez affilier les fichiers qui ont été déposés dans le devis à
          des repertoires dans le dossier
        </div>
        <div className="flex flex-row gap-10 w-full  ">
          <div className="flex flex-col gap-2 w-full  text-black">
            {invoiceData?.plans_files?.map((file, index) => (
              <div
                key={index}
                className="text-h3 flex flex-row justify-between  w-full items-center"
              >
                <div className="flex max-w-c300 flex-row gap-2 items-center bg-blue-50 break-all rounded-lg px-2 py-1 text-blue-500 ">
                  <Icon1 icon_name="file" fill="#3b82f6" size={20}></Icon1>
                  {file.name.substring(0, 30)}
                </div>
                <div className="flex w-c300  ">
                  <DropDownGPT0X
                    className={"w-full"}
                    items={repertoiresOptions}
                    value={plans_files[index]?.repertoire}
                    onChange={(e) => {
                      let new_plans_files = [...plans_files];
                      new_plans_files[index] = {
                        ...new_plans_files[index],
                        repertoire: e.value,
                      };
                      setPlansFiles(new_plans_files);
                    }}
                    label="Repertoire"
                  ></DropDownGPT0X>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col mt-6 gap-2">
          <ToggleSettingsBrick
            title="Utiliser le paiement particulier pour ce dossier"
            description={
              "Les rapports seront automatiquement disponibles au client dès que le particulier aura payé."
            }
            disabled={invoiceData.client_type === "particulier"}
            checked={payment_allowed}
            onChange={(checked) => {
              setPaymentAllowed(checked);
            }}
          ></ToggleSettingsBrick>
          {false && folder_type === "infiltro" && (
            <ToggleSettingsBrick
              title="Utiliser une facture de matériaux au lieu d'ATH"
              description={
                "Nous avons modifié le fonctionnement relatif aux factures de matériaux. Si vous voulez utiliser une facture de matériaux, ajoutez ce document au niveau de la prestation. N'hésitez pas à nous envoyer un message si vous avez besoin d'aide."
              }
              disabled={true}
              checked={use_facture_mat}
              onChange={(checked) => {
                setUseFactureMat(checked);
              }}
            ></ToggleSettingsBrick>
          )}
          <ToggleLogementBrick
            title="Inclure un CIL"
            checked={false}
            onChange={() => {}}
            description={
              "Un carnet d'information du logement sera généré et synchronisé avec le dossier."
            }
          ></ToggleLogementBrick>
        </div>
      </div>
      <div className="flex flex-row justify-end gap-2 p-4 border-t-1">
        <PrimaryButton
          className={"w-fit"}
          onClick={handleCreateFolder}
          disabled={loadingNewFolder || !selectedPack}
        >
          Initier la création du dossier{" "}
          <SmallSpinner loading={loadingNewFolder} />
        </PrimaryButton>
      </div>
    </div>
  );
};

export default CreateFolderFromDevis;
